module.exports = __webpack_public_path__ + "static/media/BeVietnamPro-SemiBold.1ec09ffe.ttf";